var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 1.5C2.56 1.5 2 2.06 2 2.75V18.75C2 19.44 2.56 20 3.25 20H4.5V14.75C4.5 13.231 5.73 12 7.25 12H15.25C16.77 12 18 13.231 18 14.75V20H19.25C19.94 20 20.5 19.44 20.5 18.75V6.061L15.94 1.5H15V5.75C15 7.269 13.77 8.5 12.25 8.5H7.25C5.73 8.5 4.5 7.269 4.5 5.75V1.5H3.25ZM6 1.5V5.75C6 6.44 6.56 7 7.25 7H12.25C12.94 7 13.5 6.44 13.5 5.75V1.5H6ZM16.5 20V14.75C16.5 14.06 15.94 13.5 15.25 13.5H7.25C6.56 13.5 6 14.06 6 14.75V20H16.5ZM0.5 2.75C0.5 1.231 1.73 0 3.25 0H16.25C16.45 0 16.64 0.079 16.78 0.22L21.78 5.22C21.92 5.36 22 5.551 22 5.75V18.75C22 20.269 20.77 21.5 19.25 21.5H3.25C1.73 21.5 0.5 20.269 0.5 18.75V2.75ZM11.25 3C11.66 3 12 3.336 12 3.75V4.75C12 5.164 11.66 5.5 11.25 5.5C10.84 5.5 10.5 5.164 10.5 4.75V3.75C10.5 3.336 10.84 3 11.25 3Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSave);
export default __webpack_public_path__ + "static/media/ico-save.f9726d0f.svg";
export { ForwardRef as ReactComponent };